import styled from "styled-components";

export const ImageStyled = styled.div`
  width: 100%;

  .hs-image {
    max-width: 100%;
    width: 100%;
  }
`;
